import Keycloak from 'keycloak-js';
import { auth } from '../config';

export const keycloak = new Keycloak({
  url: auth.auth_url,
  realm: auth.realm,
  clientId: auth.client_id,
});

/**
 * Init options shared by the provider; PKCE + no login iframe, as in the Journeys portal.
 *
 * redirectUri deliberately drops the query and hash. The portal uses `window.location.href`, which
 * means a login that lands on `/#state=…&code=…` folds those callback params into the NEXT login's
 * redirect_uri — they accumulate, and the URL stops matching what you registered in Keycloak.
 * Origin + pathname is stable and still lands the user back on the page they asked for.
 */
export const keycloakInitOptions = {
  onLoad: 'login-required' as const,
  checkLoginIframe: false,
  redirectUri: `${window.location.origin}${window.location.pathname}`,
  pkceMethod: 'S256' as const,
};

export const ACCESS_TOKEN_KEY = 'access_token';
export const CURRENT_NETWORK_KEY = 'currentNetwork';
